<template>
    <section class="padding-vertical-content" v-if="packs.data.length > 0">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 col-xl-10">
                    <ul class="grid">
                        <template v-for="pack in packs.data">
                            <PackItem v-bind:key="pack.id" :pack="pack"/>
                        </template>
                    </ul>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import PackItem from './PackItem.vue';

    export default {
        props: {
            packs: {
                type: Object,
                required: true
            }
        },
        components: {
            PackItem
        }
    }
</script>